//中转数据用
import Vue from 'vue'

export default new Vue;


// WEBPACK FOOTER //
// ./src/assets/js/signal.js